// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"aa81ec11","731":"522bd34e","912":"70e58a0f"}[chunkId] + ".chunk.css";
};